export default "__VITE_ASSET__C25nKRN6__"